"use client";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Col, Container, Row } from "react-bootstrap";
import useDeviceType from "@/components/hooks/useDeviceType";
import Title from "@/components/common/ui/text/Title";
import reactHtmlParser from "react-html-parser";
import { Img } from '@/components/common/ui/images/Img';
import { CURSOR_TEXT, DispatchCursor } from 'haspr-cursor';

const SlideOne = ({title,
					  description,
					  bannerLarge,
					  buttonLink,
					  video,
						currentIndex
				  }) => {
	const { isMobile } = useDeviceType();
	const dispatch = DispatchCursor()

	useEffect(() => {
		const navsLeft = document.querySelectorAll(".nav-left");
		const navsRight = document.querySelectorAll(".nav-right");

		navsLeft.forEach((e) => {
			e.addEventListener("click", () => {
				document.querySelector(".swiper-button-prev").click();
			});
		});

		navsRight.forEach((e) => {
			e.addEventListener("click", () => {
				document.querySelector(".swiper-button-next").click();
			});
		});
	}, [buttonLink]);

	return (
		<>
			<div className="slide-inner">
				{video ? (
					<div className={'global-image'}>
						{/* preload="none" prevents the browser fetching the video until autoplay
						    begins; the element is above-the-fold so we skip lazy intersection
						    but still avoid an eager full-download. */}
						<video
							src={bannerLarge}
							autoPlay
							muted
							loop
							playsInline
							preload="none"
						/>
					</div>
				) : (
					<Img alt={title} src={bannerLarge} priority={currentIndex === 0} />
				)}

				<Container>
					<div className="nav-left" onMouseEnter={() => CURSOR_TEXT(dispatch, <img height={40} width={40} src="/images/static/slider-left.svg" alt="" />, 'theme')} onMouseLeave={() => CURSOR_TEXT(dispatch, 'END')}></div>
					<div className="nav-right" onMouseEnter={() => CURSOR_TEXT(dispatch, <img height={40} width={40} src="/images/static/slider-right.svg" alt="" />, 'theme' )} onMouseLeave={() => CURSOR_TEXT(dispatch, 'END')}></div>
					<Row>
						<Col md={6}>
							<div className="slide-inner__info">
								<div className="side-wrapper">
									<div className="title-wrapper-middle">
										<Title
											tag={currentIndex === 0 ? 'h1' :'h2'}
											animClass={'anim-text'}
											classname={`swiper__title`}
											text={title}
											color={"#fff"}
											margin={"0"}
										/>
									</div>
								</div>
							</div>
						</Col>
					</Row>
					<Row className={'subDetails'}>
						<Col md={{ span: 6, offset: 6 }}>
							<div className="slide-inner__info">
								<div className="side-wrapper">
									<div className="middle-description">
										<p className={'anim-text'}>{reactHtmlParser(description)}</p>
									</div>

								</div>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		</>
	);
};

SlideOne.propTypes = {
	subTitle: PropTypes.string,
	title: PropTypes.string,
	classname: PropTypes.string,
	content: PropTypes.string,
	thumb: PropTypes.string,
};

export { SlideOne };
